import Vue from "vue";
import Router from "vue-router";
import routerJson from "./router";
import home from "../view/home.vue";
import login from "../view/login.vue";
import register from "../view/register.vue";
import forgetPasw from "../view/forgetPasw.vue";
import modifyPasw from "../view/modifyPasw.vue";
import notifyIndex from "../view/notify/index.vue";
import notifyDetail from "../view/notify/detail.vue";

import protocolRegister from "../view/protocol/register.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/register",
      name: "register",
      component: register,
    },
    {
      path: "/forgetPasw",
      name: "forgetPasw",
      component: forgetPasw,
    },
    {
      path: "/modifyPasw",
      name: "modifyPasw",
      component: modifyPasw,
    },
    {
      path: "/protocolRegister",
      name: "protocolRegister",
      component: protocolRegister,
    },

    {
      path: "/notify/detail",
      name: "notifyDetail",
      component: notifyDetail,
    },
    {
      path: "/",
      name: "home",
      component: home,
      children: [
        {
          path: "/",
          name: "index",
          component: () => import('@/view/index.vue'),
        },
        {
          path: "/notify/index",
          name: "notifyIndex",
          component: notifyIndex,
        },
        ...routerJson,
        {
          path: "/404",
          name: "404", 
          component: () => import('@/view/404.vue'),
        },
        {
          path: "*",
          redirect: {
            name: "404",
          },
        },
      ],
    },

    {
      path: "/404",
      name: "404",
      component: () => import('@/view/404.vue'),
    },

    {
      path: "*",
      redirect: {
        name: "404",
      },
    },
  ],
});
